import { defineStore } from "pinia";

export type PerformanceEntryType = 'api' | 'mapping' | 'display' | 'total';

export interface PerformanceEntry {
    label: string;
    type: PerformanceEntryType;
    durationMs: number;
    timestamp: number;
}

export interface PerformancePageLog {
    entries: PerformanceEntry[];
    startedAt?: number;
    completedAt?: number;
}

export const usePerformanceStore = defineStore("performance", {
    state: () => ({
        isEnabled: false as boolean,
        logs: {} as Record<string, PerformancePageLog>,
    }),
    getters: {
        getPageLogs: (state) => (page: string): PerformanceEntry[] => {
            return state.logs[page]?.entries ?? [];
        },
        getPageTotalMs: (state) => (page: string): number | undefined => {
            const log = state.logs[page];
            if (!log?.startedAt || !log?.completedAt) return undefined;
            return log.completedAt - log.startedAt;
        },
    },
    actions: {
        toggle() {
            this.isEnabled = !this.isEnabled;
        },
        addEntry(page: string, entry: PerformanceEntry) {
            if (!this.logs[page]) {
                this.logs[page] = { entries: [], startedAt: Date.now() };
            }
            this.logs[page].entries.push(entry);
        },
        clearPage(page: string) {
            this.logs[page] = { entries: [], startedAt: Date.now(), completedAt: undefined };
        },
        markComplete(page: string) {
            if (this.logs[page]) {
                this.logs[page].completedAt = Date.now();
            }
        },
    },
    persist: {
        pick: ['isEnabled'],
    },
});
